var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"map-loading-spinner"},[_c('div',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_c('strong',{staticClass:"pl-1"},[_vm._v("Loading...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }